/**
 * determines if a string starts with another string
 *
 * @returns {boolean}
 */
export const startsWith = (str, searchStr) => { // eslint-disable-line arrow-body-style
  return str && searchStr && str.toLocaleLowerCase().indexOf(searchStr.toLocaleLowerCase()) === 0;
};

export const ajaxify = (url) => `/ajax${url}`;

// normalizeCssSelector replaces any of !"#$%&'()*+,./:;<=>?@[\]^`{|}~ these characters with preceding \\
// eslint-disable-next-line no-useless-escape
export const normalizeCssSelector = (selector = '') => selector.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, '\\$&');

export default {
  startsWith,
  ajaxify,
  normalizeCssSelector,
};
